export const isFunction = (variable: unknown): variable is Function => typeof variable === 'function';
